<template>
  <div>
    <div @click="toggle" class="card-collapse d-flex align-items-center mb-3">
      <div class="pr-2">{{ title }}</div>
      <Icon :size="14" :rotate="getArrowRotation()" icon="angle-left" color="epsilon" />
    </div>
    <div v-if="show">
      <slot />
    </div>
  </div>
</template>

<script>
import Icon from "@/components/display/icon/Icon";
import { ref } from "@vue/composition-api";

export default {
  name: "CardCollapse",
  props: {
    title: {
      type: String,
      required: true,
    },
    expand: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Icon,
  },
  setup(props, { emit }) {
    const show = ref(props.expand);

    const getArrowRotation = () => (show.value ? 90 : 270);
    const toggle = () => {
      show.value = !show.value;
      emit("update:toggle", show.value);
    };

    return {
      getArrowRotation,
      show,
      toggle,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-collapse {
  cursor: pointer;
}
</style>
